<template>
  <section class="row mb-3">
    <div class="col-2">
      <div
        class="position-relative fw-bold mb-md-1 mb-2"
        style="max-width: 80px"
      >
        <img
          class="rounded-circle img-fluid"
          :src="aws + '/pauline.png'"
        >
        <div class="green-circle rounded-circle border bg-green-600" />
      </div>
    </div>
    <div class="col-10 col-md-9">
      <div class="mb-md-1 fw-bold d-flex text-md-start">
        Pauline
      </div>
      <div class="text-start">
        <span
          v-for="(item, i) in message.sentences"
          :key="item + i"
          :class="i % 2 === 1 ? 'highlight highlight-yellow-500' : ' position-relative'"
          v-html="item"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { filter } from 'lodash-es';
import onlineSentences from '@/assets/data/assistant.json';

export default {
  name: 'CommonAssistant',
  props: {
    path: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    sentences() {
      return onlineSentences.steps;
    },
    customMessage() {
      const { customMessage } = this.$store.state.ui;
      if (customMessage && customMessage.length) {
        return customMessage;
      }
      return null;
    },
    forceMessage() {
      return this.$store.state.ui.assistantMessage;
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/widget/png/account-manager`,
    message() {
      let path = this.$route.name;
      if (this.$route.query.assistant) {
        path = this.$route.query.assistant;
      }
      if (this.forceMessage !== null) {
        path = this.forceMessage;
      }
      const viewSentences = filter(this.sentences, { name: path });
      return viewSentences[0] || { sentences: this.customMessage } || {
        sentences: [
          'Dites en plus sur votre ',
          'activité principale,',
          ' que faites-vous ? Les couvertures assurances peuvent changer en fontion de votre activité.',
        ],
      };
    },
  },
};
</script>
<style scoped>
.green-circle {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 30%;
  width: 30%;
  border: 2px solid #FFFFFF !important
}
</style>
